<template>
    <div class="container">
        <div class="main">

            <el-divider content-position="left">
                <div style="font-size: 24px;">官方授权实体店</div>
            </el-divider>
            <div style="padding-bottom: 40px"></div>
            <el-form :inline="true"  >
                <el-row>
                <el-col :span="7"  >
                <el-form-item label="省份" prop="ptype">
                    <el-select v-model="province" @change="changeProv" placeholder="请选择省份">
                        <el-option v-for="item in provinces"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                <el-col :span="7"  >
                <el-form-item label="城市" prop="ptype">
                    <el-select v-model="city" @change="changeCity" placeholder="请选择城市">
                        <el-option
                                v-for="item in citys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                </el-row>
            </el-form>
            <div style="padding-bottom: 40px"></div>
            <el-row>
            <div v-for="i in dealerList"    style="margin-bottom: 40px">
                <el-card class="box-card">
                    <div style="font-size: 24px">{{i.dealerName}}</div>
                    <div style="margin-left: 2px;padding-top: 10px">联系人：{{i.contactName}}</div>
                    <div style="margin-left: 2px;padding-top: 10px">电话：{{i.contactPhone}}</div>
                    <div style="margin-left: 2px;padding-top: 10px">地址：{{i.address}}</div>
                </el-card>
            </div>
            </el-row>

            <el-divider content-position="left">
                <div style="font-size: 24px;">官方授权网店</div>

            </el-divider>
            <div style="padding-bottom: 40px"></div>
            <el-row>
                <el-col :span="2" style="cursor: pointer" >
                    <el-image style="height:58px;width:58px;"  @click="tmallClick"  :src="require('@/assets/image/home/home6/tmall1.png')"></el-image>
                </el-col>
                <el-col :span="5" style="cursor: pointer" >
                    <div  @click="tmallClick" style="margin-top: 20px;text-decoration: underline;cursor: pointer">DIXCEL天猫旗舰店</div>
                </el-col>
                <el-col :span="2"  style="cursor: pointer" >
                    <el-image style="height:58px;width:58px;"  @click="jdClick" :src="require('@/assets/image/home/home6/jd1.png')"></el-image>
                </el-col>
                <el-col :span="6"  style="cursor: pointer"  >
                    <div @click="jdClick"  style="margin-top: 20px;text-decoration: underline;cursor: pointer">DIXCEL京东旗舰店</div>
                </el-col>
            </el-row>
            <div style="padding-bottom: 40px"></div>

        </div>
    </div>
</template>


<script>
    import axios from 'axios';
    export default {
        name: 'dealerDetail',
        data() {
            return {
                // loading:true,
                provinces: [ ],
                citys: [],
                cityAll: [],
                dealerAllList: [],
                dealerList: [],
                province: '',
                city: '',

            }
        },
        created(){
            this.getDealerList()
        },
        methods:{
            tmallClick(){
                window.open( 'https://dixcel.tmall.com' , '_blank' )
            },
            jdClick(){
                window.open( 'https://mall.jd.com/index-735062.html' , '_blank' )
            },
                getCity() {
                    axios.get(this.publicUrl+'/api/user/getCity')
                        .then(response => {
                            this.provinces=JSON.parse(response.data.provinces)
                            this.cityAll=JSON.parse(response.data.citys)
                        })
                        .catch(error => {
                            console.error('There was an error!', error);
                        });
                },
                 getDealerList(){
                    axios.get(this.publicUrl+'/api/user/getDealerList')
                    .then(res => {
                        this.dealerAllList=res.data.list;
                        this.loading=false;
                        this.getCity()
                    })
                    .catch(error => {
                        console.error('There was an error!', error);
                    });
                },
                changeProv(){
                    this.citys =this.cityAll[this.province]
                    this.city = this.citys[0].id
                    this.changeCity()
                },
                changeCity(){
                    this.dealerList=[];
                    for(const d of this.dealerAllList){
                        if(d.cityCode == this.city){
                          if (d.address) {
                            d.address = d.address
                                .replace('北京北京市', '北京市')
                                .replace('上海上海市', '上海市')
                                .replace('重庆重庆市', '重庆市')
                                .replace('天津天津市', '天津市')
                          }
                            this.dealerList.push(d)
                        }

                    }

                }


            }
    }
</script>

<style lang="stylus" scoped>


    .container
        background-color: #000

        .box_one
            width: 100%;

        .box_bottom
            width: 100%;
            background-color #000


    .main {
        margin-bottom: 5px;
        width: 1003px;
        background-color: #fff;
        margin: 0 auto;
        position: relative;
        box-sizing: border-box;
        padding: 62px 50px 52px;
    }

    .title {
        color: #ab191d;
        text-align: center;
        margin-bottom 10px
    }

</style>
